export type Theme = "light";

/** Yantu 只使用明亮主题。*/
export const THEME: Theme = "light";